import { bindEvents } from '../helpers';

import CursorController from './cursor';


let overlays = {};

class OverlayController {

	constructor() {
		this.active = null;

		this.customEvents = {
			open: new CustomEvent('open'),
			close: new CustomEvent('close')
		};

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	get overlays() {
		return overlays;
	}

	set overlays(obj) {
		overlays = obj;
		this.overrideCloseButton();
		return true;
	}

	open(id) {
		if (this.active) this.close();
		overlays[id].classList.add('is-open');
		overlays[id].dispatchEvent(this.customEvents.open);
		this.active = id;
		CursorController.activeLayer = id;
	}

	close(id = this.active) {
		if (id) {
			overlays[id].classList.remove('is-open');
			overlays[id].dispatchEvent(this.customEvents.close);
			this.active = null;
			CursorController.activeLayer = CursorController.defaultLayer;
		}
	}

	_onDocumentKeyDown(e) {
		if (this.active && e.keyCode === 27) this.close();
	}

	_onCloseButtonClick(e) {
		e.preventDefault();
		this.close();
	}

	overrideCloseButton() {
		for (const id in this.overlays) {
			const closeButton = this.overlays[id].querySelector('.button-circle--close');
			closeButton.addEventListener('click', this.events._onCloseButtonClick);
		}
	}

	addEventListeners() {
		document.addEventListener('keydown', this.events._onDocumentKeyDown);
	}

	removeEventListeners() {
		document.removeEventListener('keydown', this.events._onDocumentKeyDown);
	}

}

export default new OverlayController();
